import solarLogo from 'assets/Solar_Horiz_Tagline_Color.png'
import CreditHeader from 'components/creditCheck/creditHeader'
import * as React from 'react'
import { connect } from 'react-redux'
import { RootState } from 'store/rootReducer'
import styled from 'style/styled-components'

const StyledSolarLogo = styled.img`
  max-width: 100%;
`

class CreditCheckMessagePage extends React.Component<StateProps> {
  public render(): JSX.Element {
    return (
      <div>
        <CreditHeader />
        <div className="row justify-content-center grid-section margin-top">
          <div className="col-12 col-md-8 text-center margin-top">
            <hr />
            <h3 className="margin-top margin-bottom" id="displayMessage">{this.props.displayMessage ? this.props.displayMessage : 'There was an error'}</h3>
            <hr />
          </div>
        </div>
        <footer className="footer page-footer row justify-content-center grid-section margin-top">
          <div className="col-8 col-md-2 text-center margin-top">
            <StyledSolarLogo src={solarLogo} />
          </div>
        </footer>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    displayMessage: state.creditCheck.displayMessage
  }
}

interface StateProps {
  displayMessage: string
}

export default connect<StateProps>(mapStateToProps)(CreditCheckMessagePage)



// WEBPACK FOOTER //
// ./src/components/creditCheckMessage/CreditCheckMessagePage.tsx